import { useGiftCardContext } from '@fhs/payments';

import { usePaymentMethodStore } from '../payment';

export function useSelectedGiftCard() {
  const selectedPaymentMethod = usePaymentMethodStore(state => state.selectedPaymentMethod);
  const selectedGiftCardAccountId = usePaymentMethodStore(state => state.selectedGiftCardAccountId);
  const userAccountsData = usePaymentMethodStore(state => state.userAccountsData);

  const { currentBalance, isBalanceLoading } = useGiftCardContext();

  if (selectedPaymentMethod !== 'giftCard') {
    return null;
  }

  const accounts = userAccountsData.userAccounts?.accounts ?? [];
  const account = selectedGiftCardAccountId
    ? accounts.find(
        (acc: any) =>
          acc?.accountIdentifier === selectedGiftCardAccountId ||
          acc?.fdAccountId === selectedGiftCardAccountId
      )
    : accounts.find((acc: any) => acc?.giftCard);

  const giftCard = account?.giftCard;

  if (!giftCard) {
    return null;
  }

  return {
    ...giftCard,
    currentBalance,
    isBalanceLoading,
  };
}
